import { ngRoute } from '../../../../app/routing/ngRoute';
import { PropertyFilter, setPresetsInSearchParams } from './utils';

export type Model = { filters: PropertyFilter; id: string };

export function switchExperience(model: Model): void {
    const existingSearchParams = new URLSearchParams(ngRoute.history?.location.search);
    const searchParams = new URLSearchParams();

    const density = Math.round(Number.parseFloat(existingSearchParams.get('density') ?? '1') * 60);
    if (density !== 60 && !Number.isNaN(density)) {
        searchParams.set('d', String(density));
    }

    const startTime =
        existingSearchParams.get('startTime') ??
        parseCustomTime(existingSearchParams.get('startTimeUTC'));

    if (startTime !== null) {
        const endTime =
            existingSearchParams.get('endTime') ??
            parseCustomTime(existingSearchParams.get('endTimeUTC')) ??
            'now';
        if (endTime.toLowerCase() === 'now') {
            searchParams.set('t', startTime);
        } else {
            searchParams.set('t', `${startTime}--${endTime}`);
        }
    }

    const sourcePresets: { property?: string; value?: string[] }[] =
        model.filters?.sources?.map((source) => ({
            property: source?.property,
            value: source?.value,
        })) ?? [];

    const variablePresets: { property?: string; value?: string[] }[] =
        model.filters?.variables?.map((variable) => ({
            property: variable?.property,
            value: variable?.value ?? undefined,
        })) ?? [];

    // "sf_metric:foo,foo2"
    const urlSources: { property?: string; value?: string[] }[] = Array.from(
        existingSearchParams.entries() ?? []
    )
        .map(([key, value]) => ({ key, value }))
        .filter(({ key }) => key === 'sources[]')
        .map(({ value: searchParamValue }) => {
            const [key, ...rest] = searchParamValue?.split(':');
            const values = rest.join(':').split(',');

            return {
                property: key,
                value: values,
            };
        });

    // "Account ID=aws_account_id:["1", "2"]"
    const urlVariables: { property?: string; value?: string[] }[] = Array.from(
        existingSearchParams.entries() ?? []
    )
        .map(([key, value]) => ({ key, value }))
        .filter(({ key }) => key === 'variables[]')
        .map(({ value: searchParamValue }) => {
            const [key, ...rest] = searchParamValue?.split('=').slice(1).join('=').split(':');

            let values: string[] = [];

            try {
                const parsedValues: string[] = JSON.parse(rest.join(':'));
                if (Array.isArray(parsedValues)) {
                    values = parsedValues;
                }
            } catch {}

            return {
                property: key,
                value: values,
            };
        });

    const finalSources = urlSources?.length > 0 ? urlSources : sourcePresets;
    const finalVariables = urlVariables?.length > 0 ? urlVariables : variablePresets;

    setPresetsInSearchParams(searchParams, finalSources.concat(finalVariables));

    ngRoute.history?.replace({
        pathname: `/dash/_/${model.id}`,
        search: searchParams.toString(),
    });
}

function parseCustomTime(time: string | null): string | null {
    if (time === null) {
        return null;
    }

    const numTime = Number(time);

    return !Number.isNaN(numTime) ? new Date(numTime).toISOString() : null;
}
